import { Link } from "react-router-dom";
import { UploadCloud, X } from "lucide-react";

export const ResumeFilePicker = ({ upload, prefix }) => (
  <>
    <div className="relative">
      <button type="button" onClick={() => upload.inputRef.current?.click()} data-testid={`${prefix}-dropzone`}
        className="flex w-full items-center gap-4 rounded-xl border border-dashed border-slate-300 bg-white p-5 pr-12 text-left transition-colors duration-200 hover:border-blue-600 hover:bg-blue-50">
        <UploadCloud className="h-6 w-6 shrink-0 text-blue-600" />
        <span className="min-w-0">
          <span className="block break-words text-sm font-medium text-slate-900" data-testid={`${prefix}-filename`}>
            {upload.file ? upload.file.name : "Upload your resume (PDF or DOCX)"}
          </span>
          <span className="mt-0.5 block text-xs text-slate-500">
            {upload.file ? `${(upload.file.size / 1024).toFixed(0)} KB selected` : "Max 1 MB · PDF or DOCX only"}
          </span>
        </span>
      </button>
      {upload.file && (
        <button type="button" onClick={upload.clearFile} className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-700"
          data-testid={`${prefix}-clear`} aria-label="Remove file"><X className="h-4 w-4" /></button>
      )}
    </div>
    <input ref={upload.inputRef} type="file" accept=".pdf,.docx" className="hidden" data-testid={`${prefix}-input`}
      onChange={(event) => upload.pick(event.target.files?.[0])} />
  </>
);

export const JobDescriptionField = ({ upload, prefix }) => (
  <div className="mt-3">
    {!upload.showJd ? (
      <button type="button" onClick={() => upload.setShowJd(true)} data-testid={`${prefix}-jd-toggle`} className="text-sm font-medium text-blue-700 hover:underline">
        + Add a job description (optional) for keyword alignment
      </button>
    ) : (
      <textarea rows={4} value={upload.jd} onChange={(event) => upload.setJd(event.target.value)} data-testid={`${prefix}-jd`}
        placeholder="Paste the job description to check keyword alignment (optional)."
        className="w-full resize-none rounded-xl border border-border bg-white px-4 py-3 text-sm text-slate-900 focus:border-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-600/15" />
    )}
  </div>
);

export const ResumeConsent = ({ upload, prefix }) => (
  <label className="mt-4 flex items-start gap-3 text-sm text-slate-600">
    <input type="checkbox" checked={upload.consent} onChange={(event) => upload.setConsent(event.target.checked)} data-testid={`${prefix}-consent`}
      className="mt-1 h-4 w-4 rounded border-slate-300 text-blue-600" />
    <span>I understand my resume will be retained by SCC to provide and manage the requested career
      service, in line with the <Link to="/privacy" data-testid={`${prefix}-privacy-link`} className="font-medium text-blue-700 underline">Privacy Policy</Link>.
    </span>
  </label>
);